import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "phone-bind-form"
};
import { ref } from "vue";
import { useUserStore } from "@/store/userStore";
import Common from "@/components/dialog/src/Common.vue";
import { updateUserInfo, getUserDetail, validCode } from "@/api/user";
import { showToast } from "@/utils/toastUtil";
import Dialog from "../dialog/dialog";
import FormItem from "../login/mobile/form/FormItem.vue";
import { computed } from "vue";
import { isPhoneAccount } from "../login/mobile/helper";
import { CODE_INVALID, CODE_ERROR, PHONE_BINDED } from "@/constant/responseCode";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { Notify } from "@/utils/notifyUtil";
import { useSupplierStore } from "@/store/supplierStore";
import { useI18n } from "vue-i18n";
export default {
  __name: 'PhoneBind',
  props: {
    show: {
      type: Boolean,
      required: false
    }
  },
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var props = __props;
    var formData = ref({
      calling_code: "",
      phone: "",
      code: ""
    });
    var errorForm = ref({
      phone: ""
    });
    var isDisabled = computed(function () {
      return !formData.value.phone || !formData.value.calling_code || supplierStore.getIsSMSOpen && !formData.value.code;
    });
    var userStore = useUserStore();
    var showDialog = ref(false);
    var checkParams = function checkParams() {
      var flag = true;
      if (!isPhoneAccount(formData.value.phone, formData.value.calling_code)) {
        errorForm.value.phone = t("wrongFormatOfPhoneNumber");
        flag = false;
      }
      if (flag) {
        errorForm.value.phone = "";
      }
      return flag;
    };
    function handleSave() {
      if (!checkParams()) {
        return;
      }
      Dialog.confirm({
        title: "Notice",
        desc: "Can't change after being saved",
        okText: "Yes",
        cancelText: "No",
        onOk: function onOk() {
          handleConfirm();
        }
      });
    }
    function handleConfirm() {
      return _handleConfirm.apply(this, arguments);
    }
    function _handleConfirm() {
      _handleConfirm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              showLoading();
              _context.next = 3;
              return updateUserInfo({
                phone: formData.value.phone,
                area_code: formData.value.calling_code,
                customer_id: userStore.getUserInfo.customer_id,
                verification_code: formData.value.code
              });
            case 3:
              res = _context.sent;
              hideLoading();
              if (!res.isOK) {
                _context.next = 14;
                break;
              }
              showDialog.value = false;
              showToast("Successfully");
              _context.next = 10;
              return getUserDetail();
            case 10:
              result = _context.sent;
              if (result.isOK) {
                userStore.setUserInfo(result.data);
              }
              _context.next = 15;
              break;
            case 14:
              if (res.code === CODE_INVALID || res.code === CODE_ERROR) {
                Notify.error("Verification code is invalid");
              } else if (res.code === PHONE_BINDED) {
                Notify.error("Mobile phone number has been bound");
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleConfirm.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = function () {
          return showDialog.value = true;
        })
      }, _toDisplayString(_ctx.$t("input")), 1), _createVNode(Common, {
        visible: showDialog.value,
        "onUpdate:visible": _cache[6] || (_cache[6] = function ($event) {
          return showDialog.value = $event;
        }),
        "ok-text": _ctx.$t('confirm'),
        title: _ctx.$t('phone'),
        "show-close-btn": "",
        "without-cancel": "",
        "show-bottom-shadow": "",
        "on-ok": handleSave,
        "disable-ok-button": isDisabled.value
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("form", _hoisted_1, [_createVNode(FormItem, {
            modelValue: formData.value.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return formData.value.phone = $event;
            }),
            callcode: formData.value.calling_code,
            "onUpdate:callcode": _cache[2] || (_cache[2] = function ($event) {
              return formData.value.calling_code = $event;
            }),
            error: errorForm.value.phone,
            label: _ctx.$t('phoneNumber'),
            type: "phone",
            placeholder: _ctx.$t('yourPhoneNumber'),
            onInput: _cache[3] || (_cache[3] = function ($event) {
              return errorForm.value.phone = '';
            })
          }, null, 8, ["modelValue", "callcode", "error", "label", "placeholder"]), _unref(supplierStore).getIsSMSOpen ? (_openBlock(), _createBlock(_component_Gap, {
            key: 0,
            h: 0.16
          })) : _createCommentVNode("", true), _unref(supplierStore).getIsSMSOpen ? (_openBlock(), _createBlock(FormItem, {
            key: 1,
            modelValue: formData.value.code,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return formData.value.code = $event;
            }),
            phone: formData.value.phone,
            callcode: formData.value.calling_code,
            operation: "ChangePhone",
            label: _ctx.$t('verification'),
            type: "reg",
            placeholder: _ctx.$t('verificationCode'),
            "onPhone:error": _cache[5] || (_cache[5] = function ($event) {
              return errorForm.value.phone = _ctx.$t('wrongFormatOfPhoneNumber');
            })
          }, null, 8, ["modelValue", "phone", "callcode", "label", "placeholder"])) : _createCommentVNode("", true)])];
        }),
        _: 1
      }, 8, ["visible", "ok-text", "title", "disable-ok-button"])]);
    };
  }
};